import { render, staticRenderFns } from "./GBankUpdate.vue?vue&type=template&id=cf2abaf4&lang=pug&"
import script from "./GBankUpdate.vue?vue&type=script&lang=js&"
export * from "./GBankUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "GBankUpdate.vue"
export default component.exports